// extracted by mini-css-extract-plugin
module.exports = {"listed_blog_title":"Card_listed_blog_title__A_axn","listed_blog_summary":"Card_listed_blog_summary__UyN11"};